// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/feature-purchases/feature-purchases.css
// module id = 697
// module chunks = 0